import React from 'react';
import { TopBar } from './components/TopBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { PromiseSection } from './components/PromiseSection';
import { ProductSection } from './components/ProductSection';
import { BonusSection } from './components/BonusSection';
import { ComparisonSection } from './components/ComparisonSection';
import { ValueSection } from './components/ValueSection';
import { ForWhoSection } from './components/ForWhoSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { FAQSection } from './components/FAQSection';
import { CTASection } from './components/CTASection';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen w-full" data-id="element-0">
      <TopBar data-id="element-1" />
      <HeroSection data-id="element-2" />
      <PainSection data-id="element-3" />
      <PromiseSection data-id="element-4" />
      <ProductSection data-id="element-5" />
      <BonusSection data-id="element-6" />
      <ComparisonSection data-id="element-7" />
      <ValueSection data-id="element-8" />
      <ForWhoSection data-id="element-9" />
      <TestimonialsSection data-id="element-10" />
      <GuaranteeSection data-id="element-11" />
      <UrgencySection data-id="element-12" />
      <FAQSection data-id="element-13" />
      <CTASection data-id="element-14" />
      <Footer data-id="element-15" />
    </div>;
}